import { FilterAltOff, Close, Search } from "@mui/icons-material";
import {
  Stack,
  Box,
  Tooltip,
  IconButton,
  Divider,
  Typography,
  InputAdornment,
} from "@mui/material";
import { Control, FieldValues, UseFormReturn } from "react-hook-form";
import { ItecColFilterParams } from "./types";
import {
  Multiselect,
  Select,
  TextField,
  ControlledDateRangePicker,
  ToggleButtonGroup,
  ToggleButtonGroupMultiple,
} from "src/lib/itaptec/components_forms/src";

export type FilterProps<TFilter extends FieldValues> = {
  close: () => void;
  menuParams: ItecColFilterParams<TFilter>;
  //   control: Control<TFilter>;
  formMethods: UseFormReturn<TFilter>;
};

export function Filter<TFilter extends FieldValues = FieldValues>(
  props: FilterProps<TFilter>
) {
  const {
    close,
    menuParams,
    formMethods: { control, resetField },
  } = props;

  // TODO: autofocus fields on mount
  return (
    <Stack
      minWidth={300}
      px={1}
      spacing={2}
      direction="row"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
    >
      <Box sx={{ width: "100%" }}>
        {menuParams.type === "select" && (
          <Select
            name={menuParams.name}
            control={control}
            {...menuParams.props}
          />
        )}
        {menuParams.type === "multiselect" && (
          <Multiselect
            name={menuParams.name}
            control={control}
            {...menuParams.props}
          />
        )}
        {menuParams.type === "date-range" && (
          <ControlledDateRangePicker
            label={"Fecha"}
            control={control}
            {...menuParams.props}
          />
        )}
        {menuParams.type === "text" && (
          <TextField
            name={menuParams.name}
            control={control}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            debounceTime={500}
            {...menuParams.props}
          />
        )}
        {menuParams.type === "button-group" && (
          <ToggleButtonGroup
            name={menuParams.name}
            control={control}
            {...menuParams.props}
          />
        )}
        {menuParams.type === "multiple-button-group" && (
          <ToggleButtonGroupMultiple
            name={menuParams.name}
            control={control}
            {...menuParams.props}
          />
        )}
      </Box>
      <Box display="flex">
        <Tooltip title="Limpiar filtro">
          <IconButton
            onClick={() => {
              resetField(menuParams.name);
              close();
              // onFilterChange(); // search on filter reset
            }}
          >
            <FilterAltOff />
          </IconButton>
        </Tooltip>
        <Tooltip title="Cerrar filtro">
          <IconButton onClick={close}>
            <Close />
          </IconButton>
        </Tooltip>
      </Box>
    </Stack>
  );
}
